import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Theme } from '../config/theme.js';
import { fetchStartupData } from '../actions/content';
import ReactGA from 'react-ga';

import { Provider, connect } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, autoRehydrate, storages } from 'redux-persist';
import localForage from 'localforage';
import reducer from '../reducers';
import promise from '../store/promise';

import ApplicationHelper from '../components/ApplicationHelper';
import Home from '../views/Home';
import Article from '../views/Article';
import Music from '../views/Music';
import Featured from '../views/Featured';
import Search from '../views/Search';
import Contact from '../views/Contact';
import ErrorView from '../views/ErrorView';
import Interviews from '../views/Interviews';
import Interview from '../views/Interview';
import MusicPlayer from '../components/MusicPlayer';

const appStore = applyMiddleware(thunk, promise)(createStore);
const store = autoRehydrate()(appStore)(reducer);

ReactGA.initialize('UA-110546819-1');

export default class Application extends Component {
  constructor() {
    super();
    this.state = {
      rehydrated: false
    };
  }

  componentWillMount() {
    persistStore(store, { blacklist: ['search', 'content', 'player'], storage: storages.localForage }, () => {
      this.setState({
        rehydrated: true
      });
    });
  }

  render() {
    if(!this.state.rehydrated){
      return (
        <div />
      )
    }

    return (
      <Provider store={store}>
        <BrowserRouter>
          <ApplicationHelper ga={ReactGA}>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/music" exact component={Music} />
              <Route path="/features" exact component={Featured} />
              <Route path="/interviews" exact component={Interviews} />
              <Route path="/article/:slug" component={Article}/>
              <Route path="/interview/:slug" component={Interview}/>
              <Route path="/search" component={Search}/>
              <Route path="/contact" component={Contact}/>
              <Route component={ErrorView} />
            </Switch>
            <MusicPlayer />
          </ApplicationHelper>
        </BrowserRouter>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Application.js